import { AnalyticsService, InitOptions } from './analytics-service';

export class AnalyticsServiceFactory {
    private static analyticsInstance: AnalyticsService;

    public static init(options: InitOptions): AnalyticsService {
        if (AnalyticsServiceFactory.analyticsInstance instanceof AnalyticsService) {
            throw new Error('Trying to reinitialize Analytics service after it has already been initialized');
        }
        AnalyticsServiceFactory.analyticsInstance = new AnalyticsService(options);
        return AnalyticsServiceFactory.analyticsInstance;
    };

    public static get(): AnalyticsService {
        return AnalyticsServiceFactory.analyticsInstance;
    }
}
